export default {
  Unauthorized: '抱歉，您的權限不足',
};
